import React, { useEffect, useState } from "react";

const STATUS_OPTIONS = [
  { value: "new", label: "جديد" },
  { value: "contacted", label: "تم التواصل" },
  { value: "interested", label: "مهتم" },
  { value: "closed", label: "مغلق" },
  { value: "converted", label: "تم التحويل" },
];

export default function AdminLeads() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);

  useEffect(() => {
    fetch("/api/admin/leads.php")
      .then((res) => res.json())
      .then((json) => {
        if (json.ok) setRows(json.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  const updateField = (id, field, value) => {
    setRows((rows) =>
      rows.map((r) =>
        r.id === id ? { ...r, [field]: value } : r
      )
    );
  };

  const saveRow = async (row) => {
    setSavingId(row.id);

    try {
      const res = await fetch("/api/admin/lead-update.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: row.id,
          status: row.status,
          notes: row.notes || "",
        }),
      });

      const json = await res.json();
      if (!json.ok) {
        alert("حدث خطأ أثناء الحفظ");
      }
    } catch {
      alert("تعذر الاتصال بالسيرفر");
    }

    setSavingId(null);
  };

  const convertToClient = async (id) => {
    if (!window.confirm("هل تريد تحويل هذا الطلب إلى عميل؟")) return;

    try {
      const res = await fetch("/api/admin/lead-convert.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const json = await res.json();
      if (!json.ok) {
        alert("فشل التحويل");
        return;
      }

      setRows((rows) =>
        rows.map((r) =>
          r.id === id ? { ...r, status: "converted" } : r
        )
      );
    } catch {
      alert("تعذر الاتصال بالسيرفر");
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-extrabold">تواصل معنا</h2>
        <p className="text-sm text-slate-500">
          إدارة الطلبات الواردة وتحويلها إلى فرص بيع
        </p>
      </div>

      <div className="bg-white border rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="px-4 py-3 text-right">القيمة</th>
              <th className="px-4 py-3 text-right">النوع</th>
              <th className="px-4 py-3 text-center">الحالة</th>
              <th className="px-4 py-3 text-right">ملاحظات</th>
              <th className="px-4 py-3 text-center">إجراء</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="5" className="px-4 py-6 text-center text-slate-500">
                  جاري التحميل…
                </td>
              </tr>
            )}

            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan="5" className="px-4 py-6 text-center text-slate-500">
                  لا توجد بيانات
                </td>
              </tr>
            )}

            {rows.map((row) => (
              <tr key={row.id} className="border-t align-top">
                <td className="px-4 py-3 font-mono">
                  {row.contact_value}
                </td>

                <td className="px-4 py-3">
                  {row.contact_type === "email" ? "بريد" : "هاتف"}
                </td>

                <td className="px-4 py-3 text-center">
                  <select
                    className="border rounded-lg px-2 py-1"
                    value={row.status}
                    onChange={(e) =>
                      updateField(row.id, "status", e.target.value)
                    }
                  >
                    {STATUS_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </td>

                <td className="px-4 py-3">
                  <textarea
                    className="w-full border rounded-lg px-2 py-1"
                    rows="2"
                    value={row.notes || ""}
                    onChange={(e) =>
                      updateField(row.id, "notes", e.target.value)
                    }
                  />
                </td>

                <td className="px-4 py-3 text-center space-y-2">
                  <button
                    onClick={() => saveRow(row)}
                    disabled={savingId === row.id}
                    className="px-3 py-1 rounded-lg bg-[#4A9FD8] text-white text-sm w-full disabled:opacity-50"
                  >
                    {savingId === row.id ? "جارٍ الحفظ…" : "حفظ"}
                  </button>

                  {row.status !== "converted" && (
                    <button
                      onClick={() => convertToClient(row.id)}
                      className="px-3 py-1 rounded-lg bg-green-600 text-white text-sm w-full"
                    >
                      تحويل إلى عميل
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
